export default __webpack_public_path__ + "static/media/mini_newrelic.a4cb7180.svg";